import { UserSession } from "@/modules/user/User";

export default function forUserForGuest<T>(data: { user: T; guest: T }) {
  const user = UserSession.get();
  if (user) return data.user;
  return data.guest;
}
